import script from "./customFieldsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldsComponent.vue?vue&type=script&setup=true&lang=js"

import "./customFieldsComponent.vue?vue&type=style&index=0&id=5f3a39a7&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3a39a7"]])

export default __exports__